/**
 * Fullscreen Menu Component
 */

export class FullscreenMenu {
  constructor() {
    this.menu = document.querySelector(".wps-fullscreen-menu");

    if (!this.menu) {
      return;
    }

    this.closeButton = this.menu.querySelector(".fullscreen-menu__close");

    this.isOpen = false;

    this.init();
  }

  /**
   * Initialize
   */
  init() {
    this.bindEvents();
  }

  /**
   * Bind events
   */
  bindEvents() {
    document.addEventListener("click", (e) => {
      const toggle = e.target.closest("[data-toggle-btn]");

      if (toggle) {
        e.preventDefault();
        this.openMenu();
      }

      const close = e.target.closest(".fullscreen-menu__close");

      if (close) {
        e.preventDefault();
        this.closeMenu();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        this.closeMenu();
      }
    });

    this.menu.addEventListener("click", (e) => {
      if (e.target === this.menu) {
        this.closeMenu();
      }
    });
  }

  /**
   * Open menu
   */
  openMenu() {
    this.menu.classList.add("is-open");
    document.body.classList.add("menu-open");

    this.isOpen = true;
  }

  /**
   * Close menu
   */
  closeMenu() {
    this.menu.classList.remove("is-open");
    document.body.classList.remove("menu-open");

    this.isOpen = false;
  }
}
